import React, { useState } from "react";
import ReactDOM from "react-dom";
import CustomButton, { CustomButtonProps } from "../Button";

interface ModalProps {
	title: string;
	style?: React.CSSProperties;
	children?: React.ReactNode;
	contentStyle?: React.CSSProperties;
	onClose: () => void;
	actions?: CustomButtonProps[];
}

const HoverButton: React.FC<{ action: CustomButtonProps }> = ({ action }) => {
	const [hovered, setHovered] = useState(false);

	return (
		<div
			style={{ flex: 1 }}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			<CustomButton
				{...action}
				btnStyle={{
					width: "100%",
					justifyContent: "center",
					transition: "opacity 0.15s ease, filter 0.15s ease",
					opacity: hovered ? 0.8 : 1,
					filter: hovered ? "brightness(0.92)" : "brightness(1)",
					cursor: "pointer",
				}}
			/>
		</div>
	);
};

const CustomModal: React.FC<ModalProps> = ({
	title,
	style,
	children,
	onClose,
	actions,
	contentStyle = {},
}) => {
	const [closeHovered, setCloseHovered] = useState(false);

	return ReactDOM.createPortal(
		<div
			style={{
				position: "fixed",
				inset: 0,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				backgroundColor: "rgba(0, 0, 0, 0.4)",
				zIndex: 10000,
			}}
			onClick={onClose}
		>
			<div
				style={{
					backgroundColor: "#fff",
					borderRadius: "4px",
					boxShadow: "0 4px 24px rgba(0,0,0,0.2)",
					width: "min(640px, calc(100vw - 24px))",
					maxHeight: "90dvh",
					display: "flex",
					flexDirection: "column",
					...style,
				}}
				onClick={(e) => e.stopPropagation()}
			>
				{/* Header */}
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						padding: "12px 16px",
						borderBottom: "1px solid #e0e0e0",
						fontWeight: 600,
						fontSize: "16px",
					}}
				>
					<span>{title}</span>
					<button
						onClick={onClose}
						onMouseEnter={() => setCloseHovered(true)}
						onMouseLeave={() => setCloseHovered(false)}
						style={{
							background: closeHovered ? "#f0f0f0" : "none",
							border: "none",
							cursor: "pointer",
							fontSize: "18px",
							lineHeight: 1,
							color: closeHovered ? "#333" : "#666",
							borderRadius: "4px",
							width: "28px",
							height: "28px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							transition: "background 0.15s ease, color 0.15s ease",
						}}
						aria-label="Close"
					>
						{"\u2715"}
					</button>
				</div>

				{/* Body */}
				<div
					style={{
						padding: "16px",
						overflowY: "auto",
						maxHeight: "calc(90dvh - 120px)",
						...contentStyle,
					}}
				>
					{children}
				</div>

				{/* Actions */}
				{actions && actions.length > 0 && (
					<div
						style={{
							display: "flex",
							padding: "12px 16px",
							borderTop: "1px solid #e0e0e0",
							gap: "8px",
						}}
					>
						{actions.map((action, index) => (
							<HoverButton key={index} action={action} />
						))}
					</div>
				)}
			</div>
		</div>,
		document.body
	);
};

export default CustomModal;
